import { NetworkConnectionService } from '../services/network-connection/network-connection.service';
import * as i0 from "@angular/core";
import * as i1 from "../services/network-connection/network-connection.service";
var RouterGuard = /** @class */ (function () {
    function RouterGuard(network) {
        this.network = network;
    }
    RouterGuard.prototype.canActivate = function () {
        return this.network.check();
    };
    RouterGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function RouterGuard_Factory() { return new RouterGuard(i0.ɵɵinject(i1.NetworkConnectionService)); }, token: RouterGuard, providedIn: "root" });
    return RouterGuard;
}());
export { RouterGuard };
